import { Context, Middleware } from '@nuxt/types'

// Ireland paths
const IE_PATHS = [
  '/ie/aplauz',
  '/ie/bitsa',
  '/ie/cashlib',
  '/ie/eir-mobile',
  '/ie/just-eat',
  '/ie/lycamobile',
  '/ie/mifinity',
  '/ie/mobile-top-up',
  '/ie/netflix',
  '/ie/neosurf',
  '/ie/nintendo-eshop',
  '/ie/paysafecard',
  '/ie/pcs',
  '/ie/playstation-plus',
  '/ie/playstation-store',
  '/ie/rewarble-perfect-money',
  '/ie/three',
  '/ie/tinder-gold',
  '/ie/tinder-plus',
  '/ie/toneo-first',
  '/ie/transcash',
  '/ie/treatwell',
  '/ie/twitch',
  '/ie/xbox-gift-card',
]

// Great Britain paths
const GB_PATHS = [
  '/gb/airbnb',
  '/gb/apple',
  '/gb/candy-crush',
  '/gb/cashlib',
  '/gb/cashtocode',
  '/gb/ee-mobile',
  '/gb/flexepin',
  '/gb/giffgaff',
  '/gb/google-play',
  '/gb/ikea',
  '/gb/just-eat',
  '/gb/lastminute',
  '/gb/league-of-legends',
  '/gb/lebara',
  '/gb/lush',
  '/gb/lycamobile',
  '/gb/meta-quest',
  '/gb/mifinity',
  '/gb/netflix',
  '/gb/neosurf',
  '/gb/nintendo-eshop',
  '/gb/nintendo-games',
  '/gb/nintendo-switch-online',
  '/gb/now-mobile',
  '/gb/o2-mobile',
  '/gb/paysafecard',
  '/gb/playstation-plus',
  '/gb/playstation-store',
  '/gb/steam',
  '/gb/talk-home-mobile',
  '/gb/tesco-mobile',
  '/gb/three',
  '/gb/tinder-gold',
  '/gb/tinder-plus',
  '/gb/toneo-first',
  '/gb/transcash',
  '/gb/treatwell',
  '/gb/twitch',
  '/gb/uber',
  '/gb/vodafone',
  '/gb/xbox-gift-card',
]

// New Zealand paths
const NZ_PATHS = [
  '/nz/cashlib',
  '/nz/cashtocode',
  '/nz/flexepin',
  '/nz/mifinity',
  '/nz/neosurf',
  '/nz/paysafecard',
]

// Canada paths
const CA_PATHS = [
  '/ca/airbnb',
  '/ca/burger-king',
  '/ca/cashlib',
  '/ca/cashtocode',
  '/ca/chatr-mobile',
  '/ca/cineplex-com',
  '/ca/freedom-mobile',
  '/ca/google-play',
  '/ca/h-m',
  '/ca/hotels-com',
  '/ca/koodo-mobile',
  '/ca/lucky-mobile',
  '/ca/mifinity',
  '/ca/mobile-top-up',
  '/ca/mts-wireless',
  '/ca/neosurf',
  '/ca/paysafecard',
  '/ca/playstation-plus',
  '/ca/playstation-store',
  '/ca/public-mobile',
  '/ca/sobeys',
  '/ca/spotify-premium',
  '/ca/telus',
  '/ca/transcash',
  '/ca/uber',
  '/ca/virgin-mobile',
  '/ca/xbox-gift-card',
]

// Belgium paths
const BE_PATHS = [
  '/be/adidas',
  '/be/airbnb',
  '/be/aplauz',
  '/be/bol-com',
  '/be/cashlib',
  '/be/just-eat',
  '/be/lastminute',
  '/be/neosurf',
  '/be/netflix',
  '/be/nintendo-eshop',
  '/be/nintendo-games',
  '/be/nintendo-switch-online',
  '/be/lycamobile',
  '/be/orange',
  '/be/paysafecard',
  '/be/playstation-plus',
  '/be/playstation-store',
  '/be/riot-valorant',
  '/be/spotify-premium',
  '/be/steam',
  '/be/tinder-gold',
  '/be/tinder-plus',
  '/be/toneo-first',
  '/be/treatwell',
  '/be/twitch',
  '/be/uber',
  '/be/xbox-gift-card',
  '/be/zalando',
  '/be/google-play',
]

// Denmark paths
const DK_PATHS = [
  '/dk/league-of-legends',
  '/dk/lycamobile',
  '/dk/nintendo-eshop',
  '/dk/nintendo-switch-online',
  '/dk/paysafecard',
  '/dk/playstation-plus',
  '/dk/playstation-store',
  '/dk/xbox-gift-card',
  '/dk/mifinity',
  '/dk/neosurf',
  '/dk/toneo-first',
]

// Netherlands paths
const NL_PATHS = [
  '/nl/lycamobile',
  '/nl/abon',
  '/nl/airbnb',
  '/nl/aplauz',
  '/nl/bol-com',
  '/nl/coolblue',
  '/nl/foot-locker',
  '/nl/just-eat',
  '/nl/league-of-legends',
  '/nl/libon',
  '/nl/lush',
  '/nl/netflix',
  '/nl/nike',
  '/nl/nintendo-eshop',
  '/nl/nintendo-games',
  '/nl/nintendo-switch-online',
  '/nl/one4all',
  '/nl/paysafecard',
  '/nl/playstation-plus',
  '/nl/playstation-store',
  '/nl/riot-valorant',
  '/nl/roblox',
  '/nl/steam',
  '/nl/ticketmaster',
  '/nl/treatwell',
  '/nl/twitch',
  '/nl/uber',
  '/nl/xbox-gift-card',
  '/nl/zalando',
  '/nl/primark',
  '/nl/kpn',
  '/nl/lebara',
  '/nl/mifinity',
  '/nl/neosurf',
  '/nl/tinder-gold',
  '/nl/tinder-plus',
  '/nl/toneo-first',
  '/nl/vodafone',
  '/nl/bladcadeau',
  '/nl/gamma',
  '/nl/gt-mobile',
  '/nl/odido',
  '/nl/google-play',
]

// Norway paths
const NO_PATHS = [
  '/no/league-of-legends',
  '/no/neosurf',
  '/no/netflix',
  '/no/nintendo-eshop',
  '/no/nintendo-switch-online',
  '/no/paysafecard',
  '/no/playstation-plus',
  '/no/playstation-store',
  '/no/xbox-gift-card',
  '/no/mifinity',
  '/no/toneo-first',
]

// Portugal paths
const PT_PATHS = [
  '/pt/amazon',
  '/pt/aplauz',
  '/pt/cashlib',
  '/pt/netflix',
  '/pt/neosurf',
  '/pt/paysafecard',
  '/pt/playstation-plus',
  '/pt/uzo',
  '/pt/vodafone',
  '/pt/mifinity',
  '/pt/toneo-first',
  '/pt/xbox-gift-card',
  '/pt/meo',
  '/pt/moche',
  '/pt/nos',
  '/pt/steam',
  '/pt/transcash',
]

// Sweden paths
const SE_PATHS = [
  '/se/lycamobile',
  '/se/league-of-legends',
  '/se/netflix',
  '/se/nintendo-eshop',
  '/se/nintendo-switch-online',
  '/se/paysafecard',
  '/se/playstation-plus',
  '/se/playstation-store',
  '/se/uber',
  '/se/xbox-gift-card',
  '/se/mifinity',
  '/se/neosurf',
  '/se/telenor',
  '/se/toneo-first',
  '/se/halebop',
]

// Australia paths
const AU_PATHS = [
  '/au/neosurf',
  '/au/pcs',
  '/au/paysafecard',
  '/au/cashlib',
  '/au/transcash',
  '/au/mifinity',
  '/au/cashtocode',
  '/au/amaysim',
  '/au/boost-mobile',
  '/au/neosurf1',
  '/au/playstation-store',
  '/au/uber',
]

// Germany paths
const DE_PATHS = [
  '/de/apple',
  '/de/steam',
  '/de/tiktok',
  '/de/rtl-plus',
  '/de/aplauz',
  '/de/bitsa',
  '/de/cashlib',
  '/de/just-eat',
  '/de/mifinity',
  '/de/pcs',
  '/de/razer-gold',
  '/de/toneo-first',
  '/de/paysafecard-players-pass',
  '/de/paysafecard',
  '/de/flexepin',
  '/de/abon',
  '/de/airbnb',
  '/de/aldi-talk',
  '/de/ay-yildiz',
  '/de/bildmobil',
  '/de/blau',
  '/de/blauworld',
  '/de/ca',
  '/de/candy-crush',
  '/de/congstar',
  '/de/e-plus',
  '/de/eventim',
  '/de/fonic',
  '/de/fyve',
  '/de/h-m',
  '/de/ikea',
  '/de/klarmobil',
  '/de/lastminute',
  '/de/league-of-legends',
  '/de/lebara',
  '/de/libon',
  '/de/lifecell',
  '/de/lush',
  '/de/lycamobile',
  '/de/meta-quest',
  '/de/mobi',
  '/de/mobilka',
  '/de/mtv',
  '/de/netflix',
  '/de/nike',
  '/de/nintendo-eshop',
  '/de/nintendo-games',
  '/de/o2-mobile',
  '/de/ortel-mobile',
  '/de/otelo',
  '/de/playstation-store',
  '/de/riot-valorant',
  '/de/simyo',
  '/de/spotify-premium',
  '/de/tchibo',
  '/de/telekom',
  '/de/tinder-gold',
  '/de/tinder-plus',
  '/de/transcash',
  '/de/turk-telekom',
  '/de/twitch',
  '/de/uber',
  '/de/vodafone',
  '/de/vybe-mobile',
  '/de/xbox-gift-card',
  '/de/zalando',
  '/de/cineplex',
  '/de/google-play',
]

// Austria paths
const AT_PATHS = [
  '/at/abon',
  '/at/paysafecard',
  '/at/steam',
  '/at/transcash',
  '/at/pcs',
  '/at/toneo-first',
  '/at/kobo-rakuten',
  '/at/flexepin',
  '/at/aplauz',
  '/at/neosurf',
  '/at/cashlib',
  '/at/ea-origin',
  '/at/just-eat',
  '/at/bitsa',
  '/at/mifinity',
  '/at/cashtocode',
  '/at/netflix',
  '/at/ncoin',
  '/at/nintendo-eshop',
  '/at/playstation-plus',
  '/at/playstation-store',
  '/at/pubg',
  '/at/roblox',
  '/at/tinder-gold',
  '/at/tinder-plus',
  '/at/treatwell',
  '/at/twitch',
  '/at/zalando',
  '/at/bfree',
  '/at/bob',
  '/at/drei',
  '/at/eety',
  '/at/georg',
  '/at/magenta',
  '/at/mtel',
  '/at/ticketmaster',
  '/at/wowww',
  '/at/yesss',
  '/at/yooopi',
  '/at/google-play',
]

// France paths
const FR_PATHS = [
  '/fr/pcs',
  '/fr/karma-koin',
  '/fr/flexepin',
  '/fr/cashlib',
  '/fr/deliveroo',
  '/fr/mifinity',
  '/fr/cashtocode',
  '/fr/neosurf',
  '/fr/paysafecard',
  '/fr/airbnb',
  '/fr/netflix',
  '/fr/orange',
  '/fr/playstation-plus',
  '/fr/playstation-store',
  '/fr/primark',
  '/fr/steam',
  '/fr/treatwell',
  '/fr/uber',
  '/fr/nintendo-eshop',
  '/fr/nintendo-games',
  '/fr/roblox',
  '/fr/transcash',
  '/fr/disney-plus',
  '/fr/lapostemobile',
  '/fr/meta-quest',
  '/fr/riot-valorant',
  '/fr/sfr',
  '/fr/syma',
  '/fr/tinder-gold',
  '/fr/tinder-plus',
  '/fr/toneo-first',
  '/fr/google-play',
]

// Italy paths
const IT_PATHS = [
  '/it/paysafecard',
  '/it/pcs',
  '/it/toneo-first',
  '/it/mint-prepaid',
  '/it/aplauz',
  '/it/carrefour',
  '/it/neosurf',
  '/it/ea-sports',
  '/it/cashlib',
  '/it/disney-plus',
  '/it/blizzard',
  '/it/ea-origin',
  '/it/tiktok',
  '/it/mifinity',
  '/it/bitsa',
  '/it/flexepin',
  '/it/netflix',
  '/it/onshop',
  '/it/playstation-plus',
  '/it/playstation-store',
  '/it/iliad',
  '/it/coopvoce',
  '/it/digi-mobil',
  '/it/fastweb',
  '/it/ho-mobile',
  '/it/libon',
  '/it/linkem',
  '/it/lycamobile',
  '/it/optima',
  '/it/postemobile',
  '/it/tim',
  '/it/uno-mobile',
  '/it/very-mobile',
  '/it/vodafone',
  '/it/wind-tre',
  '/it/tiscali',
  '/it/white-calling',
  '/it/tinder-gold',
  '/it/tinder-plus',
  '/it/google-play',
]

// Switzerland paths
const CH_PATHS = [
  '/ch/abon',
  '/ch/transcash',
  '/ch/paysafecard',
  '/ch/toneo-first',
  '/ch/aplauz',
  '/ch/cashlib',
  '/ch/just-eat',
  '/ch/bitsa',
  '/ch/mifinity',
  '/ch/flexepin',
  '/ch/neosurf',
  '/ch/pcs',
  '/ch/h-m',
  '/ch/netflix',
  '/ch/nintendo-eshop',
  '/ch/nintendo-switch-online',
  '/ch/playstation-plus',
  '/ch/playstation-store',
  '/ch/roblox',
  '/ch/tinder-gold',
  '/ch/tinder-plus',
  '/ch/treatwell',
  '/ch/xbox-gift-card',
  '/ch/mucho-mobile',
  '/ch/salt-mobile',
  '/ch/sunrise',
  '/ch/swisscom',
  '/ch/yallo',
  '/ch/google-play',
]

// Spain paths
const ES_PATHS = [
  '/es/paysafecard',
  '/es/pcs',
  '/es/abon',
  '/es/toneo-first',
  '/es/mint-prepaid',
  '/es/kobo-rakuten',
  '/es/flexepin',
  '/es/aplauz',
  '/es/neosurf',
  '/es/cashlib',
  '/es/disney-plus',
  '/es/blizzard',
  '/es/ea-origin',
  '/es/bitsa',
  '/es/transcash',
  '/es/mifinity',
  '/es/lycamobile',
  '/es/digimobil',
  '/es/blau',
  '/es/euskaltel',
  '/es/hablapp',
  '/es/happy-movil',
  '/es/lcr-movil',
  '/es/llamaya',
  '/es/netflix',
  '/es/playstation-plus',
  '/es/playstation-store',
  '/es/simyo',
  '/es/talkout-mobile',
  '/es/uber',
  '/es/yoigo',
  '/es/you-mobile',
  '/es/lebara',
  '/es/vodafone',
  '/es/orange',
  '/es/libon',
  '/es/movistar',
  '/es/masmovil',
  '/es/mundimovil',
  '/es/tinder-gold',
  '/es/tinder-plus',
  '/es/google-play',
]

// Poland paths
const PL_PATHS = [
  '/pl/pcs',
  '/pl/abon',
  '/pl/toneo-first',
  '/pl/allegro',
  '/pl/paysafecard',
  '/pl/flexepin',
  '/pl/neosurf',
  '/pl/bigpoint',
  '/pl/cashlib',
  '/pl/the-settlers-online',
  '/pl/bitsa',
  '/pl/transcash',
  '/pl/mifinity',
  '/pl/netflix',
  '/pl/nintendo-eshop',
  '/pl/nintendo-switch-online',
  '/pl/playstation-store',
  '/pl/roblox',
  '/pl/uber',
  '/pl/xbox-gift-card',
  '/pl/heyah',
  '/pl/just-eat',
  '/pl/polkomtel-plus',
  '/pl/tak-tak',
  '/pl/telegrosik',
  '/pl/telgro',
  '/pl/tinder-gold',
  '/pl/tinder-plus',
  '/pl/google-play',
]

// Mexico paths
const MX_PATHS = [
  '/mx/telcel',
  '/mx/mint-prepaid',
  '/mx/flexepin',
  '/mx/cashlib',
  '/mx/innova-sport',
  '/mx/minecraft',
  '/mx/razer-gold',
  '/mx/mifinity',
  '/mx/cashtocode',
  '/mx/paysafecard',
  '/mx/playstation-store',
  '/mx/nintendo-eshop',
  '/mx/flashmobile',
  '/mx/gurucomm',
  '/mx/internet-para-el-bienestar',
  '/mx/at-t-prepaid',
  '/mx/bait',
  '/mx/freedompop',
  '/mx/mimovil',
  '/mx/nemi',
  '/mx/unefon',
]

// Czech Republic paths
const CZ_PATHS = ['/cz/abon', '/cz/paysafecard', '/cz/mifinity', '/cz/neosurf']

// Finland paths
const FI_PATHS = [
  '/fi/aplauz',
  '/fi/cashlib',
  '/fi/league-of-legends',
  '/fi/neosurf',
  '/fi/netflix',
  '/fi/nintendo-eshop',
  '/fi/nintendo-switch-online',
  '/fi/paysafecard',
  '/fi/playstation-plus',
  '/fi/playstation-store',
  '/fi/toneo-first',
  '/fi/twitch',
  '/fi/xbox-gift-card',
  '/fi/razer-gold',
]

// Croatia paths
const HR_PATHS = [
  '/hr/aplauz',
  '/hr/abon',
  '/hr/bitsa',
  '/hr/cashlib',
  '/hr/mifinity',
  '/hr/netflix',
  '/hr/neosurf',
  '/hr/paysafecard',
  '/hr/pcs',
  '/hr/transcash',
]

// Hungary paths
const HU_PATHS = [
  '/hu/paysafecard',
  '/hu/flexepin',
  '/hu/mifinity',
  '/hu/neosurf',
]

// Iceland paths
const IS_PATHS = ['/is/paysafecard', '/is/mifinity', '/is/neosurf']

// Luxembourg paths
const LU_PATHS = [
  '/lu/aplauz',
  '/lu/netflix',
  '/lu/paysafecard',
  '/lu/mifinity',
  '/lu/neosurf',
]

// Latvia paths
const LV_PATHS = [
  '/lv/aplauz',
  '/lv/netflix',
  '/lv/paysafecard',
  '/lv/mifinity',
  '/lv/neosurf',
]

// Montenegro paths
const ME_PATHS = ['/me/cashtocode', '/me/mifinity']

// Malta paths
const MT_PATHS = [
  '/mt/aplauz',
  '/mt/netflix',
  '/mt/paysafecard',
  '/mt/mifinity',
  '/mt/neosurf',
]

// Slovenia paths
const SI_PATHS = ['/si/abon', '/si/aplauz', '/si/mifinity', '/si/netflix']

// Slovakia paths
const SK_PATHS = [
  '/sk/abon',
  '/sk/aplauz',
  '/sk/cashlib',
  '/sk/netflix',
  '/sk/neosurf',
  '/sk/paysafecard',
  '/sk/xbox-gift-card',
  '/sk/mifinity',
  '/sk/toneo-first',
]

// Bulgaria paths
const BG_PATHS = ['/bg/paysafecard', '/bg/mifinity', '/bg/neosurf']

// Bosnia and Herzegovina paths
const BH_PATHS = ['/bh/cashtocode', '/bh/mifinity']

// Brazil paths
const BR_PATHS = [
  '/br/tim',
  '/br/cashtocode',
  '/br/flexepin',
  '/br/mifinity',
  '/br/claro',
  '/br/algar-telecom',
  '/br/nextel',
  '/br/vivo',
]

// Greece paths
const GR_PATHS = [
  '/gr/abon',
  '/gr/aplauz',
  '/gr/cashlib',
  '/gr/ikea',
  '/gr/mifinity',
  '/gr/netflix',
  '/gr/playstation-plus',
  '/gr/playstation-store',
  '/gr/toneo-first',
  '/gr/xbox-gift-card',
  '/gr/cosmote',
  '/gr/nova',
  '/gr/q-telecom',
]

// Israel paths
const IL_PATHS = ['/il/cashtocode', '/il/mifinity']

// India paths
const IN_PATHS = [
  '/in/airtel',
  '/in/vodafone',
  '/in/cashtocode',
  '/in/mifinity',
  '/in/bsnl',
  '/in/jio',
]

// Japan paths
const JP_PATHS = ['/jp/cashtocode', '/jp/mifinity']

// Lithuania paths
const LT_PATHS = [
  '/lt/aplauz',
  '/lt/netflix',
  '/lt/paysafecard',
  '/lt/cashtocode',
  '/lt/mifinity',
  '/lt/neosurf',
  '/lt/tele2',
]

// Morocco paths
const MA_PATHS = [
  '/ma/cashtocode',
  '/ma/mifinity',
  '/ma/inwi',
  '/ma/maroc-telecom',
  '/ma/orange',
]

// Romania paths
const RO_PATHS = [
  '/ro/abon',
  '/ro/paysafecard',
  '/ro/mifinity',
  '/ro/telekom',
  '/ro/orange',
]

// United States paths
const US_PATHS = [
  '/us/access-wireless',
  '/us/adidas',
  '/us/airbnb',
  '/us/airvoice-wireless',
  '/us/american-eagle',
  '/us/asos',
  '/us/athleta',
  '/us/banana-republic',
  '/us/bath-body-works',
  '/us/beau-jo',
  '/us/blaze-pizza',
  '/us/boohoo',
  '/us/boohooman',
  '/us/boost-mobile',
  '/us/buffalo-wild-wings',
  '/us/build-a-bear',
  '/us/burger-king',
  '/us/candy-crush',
  '/us/dave-and-busters',
  '/us/dazn',
  '/us/dominos-pizza',
  '/us/doordash',
  '/us/ebay',
  '/us/fanatics-gift-card',
  '/us/fanatics-mlb-shop',
  '/us/fanatics-nba-store',
  '/us/fanatics-nfl-shop',
  '/us/fanatics-nhl-shop',
  '/us/fandango',
  '/us/game-grub-swap',
  '/us/gamestop',
  '/us/gap',
  '/us/gap-options',
  '/us/go-smart-mobile',
  '/us/good2go',
  '/us/groupon',
  '/us/grubhub',
  '/us/h-m',
  '/us/h2o-wireless',
  '/us/home-chef',
  '/us/ikea',
  '/us/league-of-legends',
  '/us/liberty-mobile',
  '/us/lowes',
  '/us/lycamobile',
  '/us/metropcs',
  '/us/minecraft',
  '/us/nastygal',
  '/us/net10-wireless',
  '/us/nintendo-eshop',
  '/us/old-navy',
  '/us/olive-garden',
  '/us/one4all',
  '/us/outback',
  '/us/page-plus',
  '/us/pinstripes',
  '/us/playstation-store',
  '/us/razer-gold',
  '/us/red-pocket',
  '/us/riot-valorant',
  '/us/simple-mobile',
  '/us/sonic',
  '/us/stubhub',
  '/us/subway',
  '/us/taco-bell',
  '/us/tinder-gold',
  '/us/total-wine-and-more',
  '/us/tracfone',
  '/us/tripgift',
  '/us/twitch',
  '/us/uber',
  '/us/ulta-beauty',
  '/us/ultra-mobile',
  '/us/wayfair',
  '/us/xbox-gift-card',
  '/us/amc-theatres',
  '/us/cricket-wireless',
  '/us/gap-athleta-girl',
  '/us/giving-good-feeding-america',
  '/us/sling-tv',
  '/us/thank-you-swap',
  '/us/victorias-secret-gift-card',
  '/us/visa-gift-card',
  '/us/google-play',
  '/us/verizon',
]

// Afghanistan paths
const AF_PATHS = [
  '/af/afghan-wireless',
  '/af/roshan',
  '/af/etisalat',
  '/af/salaam',
]

// Dominican Republic paths
const DO_PATHS = [
  '/do/altice',
  '/do/cashlib',
  '/do/claro',
  '/do/viva',
  '/do/cashtocode',
]

// Algeria paths
const DZ_PATHS = ['/dz/cashlib', '/dz/djezzy', '/dz/mobilis', '/dz/ooredoo']

// Ethiopia paths
const ET_PATHS = [
  '/et/boomplay',
  '/et/cashlib',
  '/et/ethiotelecom',
  '/et/safaricom',
]

// Ghana paths
const GH_PATHS = [
  '/gh/boomplay',
  '/gh/cashlib',
  '/gh/mtn',
  '/gh/airteltigo',
  '/gh/glo',
]

// Gambia paths
const GM_PATHS = [
  '/gm/africell',
  '/gm/boomplay',
  '/gm/cashlib',
  '/gm/gamcel',
  '/gm/qcell',
]

// Guatemala paths
const GT_PATHS = ['/gt/cashlib', '/gt/claro', '/gt/tigo']

// Haiti paths
const HT_PATHS = ['/ht/digicel', '/ht/natcom', '/ht/cashlib']

// Jamaica paths
const JM_PATHS = ['/jm/cashlib']

// Nigeria paths
const NG_PATHS = [
  '/ng/9mobile',
  '/ng/boomplay',
  '/ng/cashlib',
  '/ng/glo',
  '/ng/mtn',
]

// Philippines paths
const PH_PATHS = [
  '/ph/cashlib',
  '/ph/cashtocode',
  '/ph/globe',
  '/ph/mifinity',
  '/ph/smart',
  '/ph/smartbro',
  '/ph/tnt',
  '/ph/touch-mobile',
  '/ph/viber',
]

// Puerto Rico paths
const PR_PATHS = [
  '/pr/at-t-prepaid',
  '/pr/cashlib',
  '/pr/claro',
  '/pr/verizon',
  '/pr/t-mobile',
]

// El Salvador paths
const SV_PATHS = ['/sv/cashlib']

// Trinidad and Tobago paths
const TT_PATHS = [
  '/tt/cashtocode',
  '/tt/digicel',
  '/tt/mifinity',
  '/tt/cashlib',
  '/tt/bmobile',
]

// Uruguay paths
const UY_PATHS = ['/uy/cashlib', '/uy/paysafecard', '/uy/antel']

// Argentina paths
const AR_PATHS = ['/ar/claro']

// Colombia paths
const CO_PATHS = ['/co/claro', '/co/avantel', '/co/etb', '/co/mifinity']

// Costa Rica paths
const CR_PATHS = ['/cr/claro', '/cr/tuyo-movil', '/cr/fullmovil']

// Ecuador paths
const EC_PATHS = ['/ec/claro', '/ec/cnt']

// Honduras paths
const HN_PATHS = ['/hn/claro']

// Nicaragua paths
const NI_PATHS = ['/ni/claro']

// Panama paths
const PA_PATHS = ['/pa/claro', '/pa/cable-and-wireless', '/pa/cashtocode']

// Peru paths
const PE_PATHS = ['/pe/claro']

// Antigua and Barbuda paths
const AG_PATHS = ['/ag/digicel']

// Anguilla paths
const AI_PATHS = ['/ai/digicel']

// Aruba paths
const AW_PATHS = ['/aw/digicel']

// Barbados paths
const BB_PATHS = ['/bb/digicel']

// Bermuda paths
const BM_PATHS = ['/bm/digicel']

// Cape Verde paths
const CV_PATHS = ['/cv/digicel', '/cv/uniteltmais']

// Dominica paths
const DM_PATHS = ['/dm/digicel']

// Fiji paths
const FJ_PATHS = ['/fj/digicel']

// Grenada paths
const GD_PATHS = ['/gd/digicel']

// Guyana paths
const GY_PATHS = ['/gy/digicel', '/gy/gtt']

// Saint Kitts and Nevis paths
const KN_PATHS = ['/kn/digicel']

// Cayman Islands paths
const KY_PATHS = ['/ky/digicel']

// Saint Lucia paths
const LC_PATHS = ['/lc/digicel']

// Papua New Guinea paths
const PG_PATHS = ['/pg/digicel']

// Suriname paths
const SR_PATHS = ['/sr/digicel']

// Turks and Caicos Islands paths
const TC_PATHS = ['/tc/digicel']

// Tonga paths
const TO_PATHS = ['/to/digicel']

// Saint Vincent and the Grenadines paths
const VC_PATHS = ['/vc/digicel']

// British Virgin Islands paths
const VG_PATHS = ['/vg/digicel']

// Vanuatu paths
const VU_PATHS = ['/vu/digicel']

// United Arab Emirates paths
const AE_PATHS = [
  '/ae/du-mobile',
  '/ae/five-mobile',
  '/ae/netflix',
  '/ae/playstation-plus',
  '/ae/playstation-store',
]

// Azerbaijan paths
const AZ_PATHS = ['/az/bakcell']

// Bangladesh paths
const BD_PATHS = [
  '/bd/banglalink',
  '/bd/grameenphone',
  '/bd/teletalk',
  '/bd/robiaxiata',
]

// Bolivia paths
const BO_PATHS = ['/bo/entel', '/bo/viva']

// Bonaire paths
const BQ_PATHS = ['/bq/telcell', '/bq/uts']

// Bahamas paths
const BS_PATHS = ['/bs/aliv', '/bs/mifinity']

// Botswana paths
const BW_PATHS = ['/bw/mascom', '/bw/orange']

// Democratic Republic of the Congo paths
const CD_PATHS = ['/cd/tatem', '/cd/africell', '/cd/orange']

// Chile paths
const CL_PATHS = ['/cl/telsur', '/cl/vtr', '/cl/wom', '/cl/entel']

// Cyprus paths
const CY_PATHS = ['/cy/epic', '/cy/paysafecard']

// Indonesia paths
const ID_PATHS = [
  '/id/axis',
  '/id/indosat-ooredoo',
  '/id/smartfren',
  '/id/telkomsel',
  '/id/tri',
  '/id/xl',
]

// Iraq paths
const IQ_PATHS = ['/iq/asiacelltelecom']

// Kyrgyzstan paths
const KG_PATHS = ['/kg/megacom', '/kg/beeline']

// Cambodia paths
const KH_PATHS = ['/kh/metfone', '/kh/cellcard', '/kh/smart']

// Comoros paths
const KM_PATHS = ['/km/comores-telecom']

// Sri Lanka paths
const LK_PATHS = ['/lk/dialog', '/lk/mobitel']

// Liberia paths
const LR_PATHS = ['/lr/lonestar', '/lr/orange']

// Malaysia paths
const MY_PATHS = [
  '/my/celcom',
  '/my/halo-telco',
  '/my/hellosim',
  '/my/hotlink',
  '/my/maxis',
  '/my/onecall',
  '/my/onexox',
  '/my/redone',
  '/my/tunetalk',
  '/my/yes',
  '/my/digi',
]

// Niger paths
const NE_PATHS = ['/ne/zamani', '/ne/moov']

// Nepal paths
const NP_PATHS = ['/np/ncell', '/np/ntc']

// Oman paths
const OM_PATHS = ['/om/omantel', '/om/renna-mobile']

// Pakistan paths
const PK_PATHS = [
  '/pk/jazz',
  '/pk/mobilink',
  '/pk/ufone',
  '/pk/warid',
  '/pk/zong',
]

// Saudi Arabia paths
const SA_PATHS = [
  '/sa/friendi-mobile',
  '/sa/mobily',
  '/sa/netflix',
  '/sa/playstation-store',
  '/sa/stc',
  '/sa/zain',
]

// Singapore paths
const SG_PATHS = ['/sg/m1']

// Senegal paths
const SN_PATHS = ['/sn/expresso-telecom', '/sn/free']

// Thailand paths
const TH_PATHS = ['/th/tot', '/th/true-move-h', '/th/ais', '/th/dtac', '/th/my']

// Tajikistan paths
const TJ_PATHS = [
  '/tj/beeline',
  '/tj/megafon',
  '/tj/babilonmobile',
  '/tj/tcell',
]

// Turkey paths
const TR_PATHS = ['/tr/carrefour', '/tr/ikea', '/tr/turkcell']

// Tanzania paths
const TZ_PATHS = ['/tz/halotel', '/tz/vodacom']

// Uzbekistan paths
const UZ_PATHS = ['/uz/beeline', '/uz/ucell', '/uz/uzmobile']

// Samoa paths
const WS_PATHS = ['/ws/bluesky']

// South Africa paths
const ZA_PATHS = ['/za/cell-c', '/za/telkom-mobile', '/za/vodacom']

// Zambia paths
const ZM_PATHS = ['/zm/zamtel']

// Cuba paths
const CU_PATHS = ['/cu/cubacel']

// Curaçao paths
const CW_PATHS = ['/cw/uts-chippie']

// China paths
const CN_PATHS = ['/cn/china-mobile']

// Venezuela paths
const VE_PATHS = ['/ve/cashtocode', '/ve/digitel']

// Vietnam paths
const VN_PATHS = ['/vn/mobifone', '/vn/viettel']

// Estonia paths
const EE_PATHS = ['/ee/aplauz']

// Kenya paths
const KE_PATHS = ['/ke/safaricom', '/ke/telkom']

// Mali paths
const ML_PATHS = ['/ml/malitel', '/ml/orange']

// Mozambique paths
const MZ_PATHS = ['/mz/mcel', '/mz/movitel']

// Namibia paths
const NA_PATHS = ['/na/boomplay', '/na/mtc']

// Tunisia paths
const TN_PATHS = ['/tn/tunisie-telecom', '/tn/orange']

// Uganda paths
const UG_PATHS = ['/ug/uganda-telecom']

// Belize paths
const BZ_PATHS = ['/bz/smart']

// French Guiana paths
const GF_PATHS = ['/gf/mifinity']

// Burkina Faso paths
const BF_PATHS = ['/bf/orange']

// Central African Republic paths
const CF_PATHS = ['/cf/orange']

// Moldova paths
const MD_PATHS = ['/md/orange']

// Madagascar paths
const MG_PATHS = ['/mg/orange']

// Guinea paths
const GN_PATHS = ['/gn/orange']

const HOME_PATHS = [
  '/gb',
  '/us',
  '/ca',
  '/au',
  '/nz',
  '/ie',
  '/be',
  '/dk',
  '/nl',
  '/no',
  '/pt',
  '/se',
  '/de',
  '/at',
  '/fr',
  '/it',
  '/ch',
  '/es',
  '/pl',
  '/mx',
  '/cz',
  '/fi',
  '/hr',
  '/hu',
  '/is',
  '/lu',
  '/lv',
  '/me',
  '/mt',
  '/si',
  '/sk',
  '/bg',
  '/bh',
  '/br',
  '/gr',
  '/il',
  '/in',
  '/jp',
  '/lt',
  '/ma',
  '/ro',
  '/af',
  '/bf',
  '/do',
  '/dz',
  '/et',
  '/gh',
  '/gm',
  '/gt',
  '/ht',
  '/jm',
  '/ng',
  '/ph',
  '/pr',
  '/sv',
  '/tt',
  '/uy',
  '/ar',
  '/co',
  '/cr',
  '/ec',
  '/hn',
  '/ni',
  '/pa',
  '/pe',
  '/ag',
  '/ai',
  '/aw',
  '/bb',
  '/bm',
  '/bz',
  '/cv',
  '/dm',
  '/fj',
  '/gd',
  '/gf',
  '/gy',
  '/kn',
  '/ky',
  '/lc',
  '/pg',
  '/sr',
  '/tc',
  '/to',
  '/vc',
  '/vg',
  '/vu',
  '/ae',
  '/az',
  '/bd',
  '/bo',
  '/bq',
  '/bs',
  '/bw',
  '/cd',
  '/cf',
  '/cu',
  '/cw',
  '/cy',
  '/id',
  '/iq',
  '/kg',
  '/kh',
  '/km',
  '/lk',
  '/lr',
  '/md',
  '/mg',
  '/my',
  '/ne',
  '/np',
  '/om',
  '/pk',
  '/sa',
  '/sg',
  '/sn',
  '/th',
  '/tz',
  '/tj',
  '/tr',
  '/uz',
  '/ws',
  '/za',
  '/zm',
  '/cl',
  '/cn',
  '/ve',
  '/vn',
  '/ee',
  '/ke',
  '/ml',
  '/mz',
  '/na',
  '/tn',
  '/ug',
  '/gn',
]

// Combine all paths into one array
const TWO_POINT_O_PATHS = [
  ...IE_PATHS,
  ...GB_PATHS,
  ...NZ_PATHS,
  ...CA_PATHS,
  ...BE_PATHS,
  ...DK_PATHS,
  ...NL_PATHS,
  ...NO_PATHS,
  ...PT_PATHS,
  ...SE_PATHS,
  ...AU_PATHS,
  ...DE_PATHS,
  ...AT_PATHS,
  ...FR_PATHS,
  ...IT_PATHS,
  ...CH_PATHS,
  ...ES_PATHS,
  ...PL_PATHS,
  ...MX_PATHS,
  ...CZ_PATHS,
  ...FI_PATHS,
  ...HR_PATHS,
  ...HU_PATHS,
  ...IS_PATHS,
  ...LU_PATHS,
  ...LV_PATHS,
  ...ME_PATHS,
  ...MT_PATHS,
  ...SI_PATHS,
  ...SK_PATHS,
  ...BG_PATHS,
  ...BH_PATHS,
  ...BR_PATHS,
  ...GR_PATHS,
  ...IL_PATHS,
  ...IN_PATHS,
  ...JP_PATHS,
  ...LT_PATHS,
  ...MA_PATHS,
  ...RO_PATHS,
  ...US_PATHS,
  ...AF_PATHS,
  ...BF_PATHS,
  ...DO_PATHS,
  ...DZ_PATHS,
  ...ET_PATHS,
  ...GH_PATHS,
  ...GM_PATHS,
  ...GT_PATHS,
  ...HT_PATHS,
  ...JM_PATHS,
  ...NG_PATHS,
  ...PH_PATHS,
  ...PR_PATHS,
  ...SV_PATHS,
  ...TT_PATHS,
  ...UY_PATHS,
  ...AR_PATHS,
  ...CO_PATHS,
  ...CR_PATHS,
  ...EC_PATHS,
  ...HN_PATHS,
  ...NI_PATHS,
  ...PA_PATHS,
  ...PE_PATHS,
  ...AG_PATHS,
  ...AI_PATHS,
  ...AW_PATHS,
  ...BB_PATHS,
  ...BM_PATHS,
  ...BZ_PATHS,
  ...CV_PATHS,
  ...DM_PATHS,
  ...FJ_PATHS,
  ...GD_PATHS,
  ...GF_PATHS,
  ...GY_PATHS,
  ...KN_PATHS,
  ...KY_PATHS,
  ...LC_PATHS,
  ...PG_PATHS,
  ...SR_PATHS,
  ...TC_PATHS,
  ...TO_PATHS,
  ...VC_PATHS,
  ...VG_PATHS,
  ...VU_PATHS,
  ...AE_PATHS,
  ...AZ_PATHS,
  ...BD_PATHS,
  ...BO_PATHS,
  ...BQ_PATHS,
  ...BS_PATHS,
  ...BW_PATHS,
  ...CD_PATHS,
  ...CF_PATHS,
  ...CU_PATHS,
  ...CW_PATHS,
  ...CY_PATHS,
  ...ID_PATHS,
  ...IQ_PATHS,
  ...KG_PATHS,
  ...KH_PATHS,
  ...KM_PATHS,
  ...LK_PATHS,
  ...LR_PATHS,
  ...MD_PATHS,
  ...MG_PATHS,
  ...MY_PATHS,
  ...NE_PATHS,
  ...NP_PATHS,
  ...OM_PATHS,
  ...PK_PATHS,
  ...SA_PATHS,
  ...SG_PATHS,
  ...SN_PATHS,
  ...TH_PATHS,
  ...UZ_PATHS,
  ...TJ_PATHS,
  ...TR_PATHS,
  ...TZ_PATHS,
  ...WS_PATHS,
  ...ZA_PATHS,
  ...ZM_PATHS,
  ...CL_PATHS,
  ...CN_PATHS,
  ...VE_PATHS,
  ...VN_PATHS,
  ...EE_PATHS,
  ...KE_PATHS,
  ...ML_PATHS,
  ...MZ_PATHS,
  ...NA_PATHS,
  ...TN_PATHS,
  ...UG_PATHS,
  ...GN_PATHS,
]

const routeToTwoPointO: Middleware = ({ next, route }: Context) => {
  if (process.server) return

  if (TWO_POINT_O_PATHS.some(path => route.path.includes(path))) {
    window.location.href = route.path
    next?.(false)
  }
  if (HOME_PATHS.some(path => route.path.endsWith(path))) {
    window.location.href = route.path
    next?.(false)
  }
}

export default routeToTwoPointO
